import React from "react";
import { SFSideMenu } from "@sf-core";
import env from "../../env";
import PropTypes from "prop-types";
import { useAuth0 } from "@auth0/auth0-react";

// import useTimer from "../../hooks/useTimer";

const SideMenuLayout = (props) => {
  const { user } = useAuth0();
  const username = user.name ? user.name : user.username.substring(0, 1);

  // useTimer();

  return <SFSideMenu routes={props.routes} username={username} env={env} {...props} />;
};

SideMenuLayout.propTypes = {
  headerOnly: PropTypes.bool,
  routes: PropTypes.any,
};

export default SideMenuLayout;
